module.exports = require('./react-handsontable.jsx').default;




// WEBPACK FOOTER //
// ./src/index.js